import { defineMessages } from 'react-intl';

export const ALREADY_VERIFIED = 'Already Verified';
export const CODE_ERROR = 'phone_verification_code_error';
export const CODE_LENGTH = 4;
export const DELIVERY_METHOD_SMS = 'sms';
export const DELIVERY_METHOD_VOICE = 'voice';
export const DUPLICATE_NUMBER = 'Duplicate Number';
export const DUPLICATE_NUMBER_ERROR = 'phone_verification_duplicate_error';
export const ERROR_CODE_MAPPING = defineMessages({
  400: {
    id: 'phoneVerification.error.bad-number',
    defaultMessage: 'Please provide a valid phone number.',
  },
  403: {
    id: 'phoneVerification.error.bad-code',
    defaultMessage: 'This code is incorrect, please try again.',
  },
  429: {
    id: 'phoneVerification.error.rate-limit',
    defaultMessage:
      'You’ve exceeded the maximum number of verification attempts in this period. Please wait an hour and try again.',
  },
});
